import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {useHitSearchSubmit} from "../../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {useAppSelector} from "../../../store/hooks";
import {IOfferModalQueryParams, OfferModal} from "../../components/offer_modal/OfferModal";
import {useOfferModalOffers} from "../../hooks/use_offer_modal_offers";
import {IOfferModalName} from "../../types/OfferModalName";

const modalName: IOfferModalName = "mainOfferModal";

export function DefaultOfferListingModal() {
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);
    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const modalListingPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const modalListingPageSize = useSelector((state: IRPStore) => state.offerList.list.page_size);
    const privilegedOffers = useSelector((state: IRPStore) => state.offerList.list.privileged_offers);

    const modalQueryParams: IOfferModalQueryParams = {
        listingPage: modalListingPage,
        listingPageSize: modalListingPageSize
    };

    const listingQueryParams = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const modalQuery = {...listingQueryParams, page_size: pageSize, page: page};
    const defaultModalListingQuery = useOfferModalOffers(!isOpen, modalQuery, privilegedOffers);
    const hitSearchSubmit = useHitSearchSubmit();

    const searchFormSubmit = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {...listingQueryParams, page},
        listFriendlyLink: ({friendlySlug, offerListSubFilterSlug}) => {
            if (offerListSubFilterSlug) {
                return rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug});
            }

            return rpAppLink.offer.listFriendly({friendlySlug});
        },
        abroadListFriendlyLink: (params) => {
            return rpAppLink.offer.listFriendlyAbroad(params);
        },
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={defaultModalListingQuery}
            initialQueryParams={modalQueryParams}
            onClose={(modalConfig) => {
                searchFormSubmit({
                    ...(searchFormValues as SearchFormValuesType),
                    floor_choices: modalConfig.filters.floor_choices,
                    house_storeys: modalConfig.filters.house_storeys,
                    area: modalConfig.filters.area,
                    rooms: modalConfig.filters.rooms
                });
            }}
        />
    );
}
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {useHitSearchSubmit} from "../../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {useAppSelector} from "../../../store/hooks";
import {IOfferModalQueryParams, OfferModal} from "../../components/offer_modal/OfferModal";
import {useOfferModalOffers} from "../../hooks/use_offer_modal_offers";
import {IOfferModalName} from "../../types/OfferModalName";

const modalName: IOfferModalName = "mainOfferModal";

export function DefaultOfferListingModal() {
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);
    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const modalListingPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const modalListingPageSize = useSelector((state: IRPStore) => state.offerList.list.page_size);
    const privilegedOffers = useSelector((state: IRPStore) => state.offerList.list.privileged_offers);

    const modalQueryParams: IOfferModalQueryParams = {
        listingPage: modalListingPage,
        listingPageSize: modalListingPageSize
    };

    const listingQueryParams = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const modalQuery = {...listingQueryParams, page_size: pageSize, page: page};
    const defaultModalListingQuery = useOfferModalOffers(!isOpen, modalQuery, privilegedOffers);
    const hitSearchSubmit = useHitSearchSubmit();

    const searchFormSubmit = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: {...listingQueryParams, page},
        listFriendlyLink: ({friendlySlug, offerListSubFilterSlug}) => {
            if (offerListSubFilterSlug) {
                return rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug});
            }

            return rpAppLink.offer.listFriendly({friendlySlug});
        },
        abroadListFriendlyLink: (params) => {
            return rpAppLink.offer.listFriendlyAbroad(params);
        },
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={defaultModalListingQuery}
            initialQueryParams={modalQueryParams}
            onClose={(modalConfig) => {
                searchFormSubmit({
                    ...(searchFormValues as SearchFormValuesType),
                    floor_choices: modalConfig.filters.floor_choices,
                    house_storeys: modalConfig.filters.house_storeys,
                    area: modalConfig.filters.area,
                    rooms: modalConfig.filters.rooms
                });
            }}
        />
    );
}
